import React, { useEffect } from 'react';

import { useEscapeToClose } from '../../hooks/useEscapeToClose';
function TrainerReportProgressModal({ progress, isComplete, onDismiss }) {
  useEscapeToClose(onDismiss);   // Escape dismisses this modal
  useEffect(() => {
    // Auto-close after 1 minute if complete
    if (isComplete && progress >= 100) {
      const timer = setTimeout(() => {
        onDismiss();
      }, 60000); // 60 seconds

      return () => clearTimeout(timer);
    }
  }, [isComplete, progress, onDismiss]);

  return (
  <div className="modal-overlay">
      <div className="progress-modal-box">
        <h2 className="progress-title">
          Generating Fitness Report
        </h2>

        {/* Progress Bar */}
        <div className="progress-bar-container">
          <div className="progress-bar-fill" style={{ width: `${progress}%` }}>
            {progress > 10 && `${progress}%`}
          </div>
          {progress <= 10 && (
            <div className="progress-bar-text">
              {progress}%
            </div>
          )}
        </div>

        {/* Status Messages */}
        {!isComplete && (
          <p className="progress-status">
            {progress < 30 && 'Initializing report generation...'}
            {progress >= 30 && progress < 60 && 'Compiling your fitness data...'}
            {progress >= 60 && progress < 90 && 'Generating PDF document...'}
            {progress >= 90 && progress < 100 && 'Sending email to trainers...'}
          </p>
        )}

        {isComplete && (
          <p className="progress-complete">
            Report Completed and Sent - click Dismiss to close window
          </p>
        )}

        {/* Dismiss Button */}
        <div className="flex-row-center">
          <button
            onClick={onDismiss}
            title="Dismiss for background processing"
            className="btn-primary-lg"
          >
            Dismiss
          </button>
        </div>
      </div>
    </div>
  );
}

export default TrainerReportProgressModal;
